import { FaHouseLock, FaBuildingLock } from 'react-icons/fa6';

const solutions = [
    {
        id: 1,
        icon: <FaHouseLock />, // House lock icon for Residential CCTV Solutions
        title: 'Residential CCTV Solutions',
        link: "Services"
    },
    {
        id: 2,
        icon: <FaBuildingLock />, // Building lock icon for Commercial CCTV Solutions
        title: 'Commercial CCTV Solutions',
        link: "Services"
    },
];

export default solutions;
